/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {TableInfoFormComponent as ɵc} from './tableinfo-form/tableinfo-form.component';
export {TableInfoComponent as ɵb} from './tableinfo.component';
export {declaration as ɵa} from './tableinfo.module';
export {TableInfoRoutes as ɵd} from './tableinfo.routing';